export const deferToAfterReflow = (framesCount, fn, i=0) => {
  if (!Number.isFinite(i)) i = 0 // ie does not support default function args

  if (i++ === framesCount) return fn()

  window.requestAnimationFrame(() => (
    deferToAfterReflow(framesCount, fn, i)))
}

